import CustomZObject from './CustomZObject.js';
import * as THREE from "three";

const err = console.error;
window.errors = [];
console.error = (... args) => {
    window.errors.push(args);
    // err(...args);
};
export default class ZShaderMaterial extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("vertex shader", ([shader]) => this.onVertexShader(shader));
        this.newInlet("fragment shader", ([shader]) => this.onFragmentShader(shader));

        this.newOutlet("material");

        this.uniforms = {};
    }

    getJson(isPreset) {
        return {
            ... super.getJson(isPreset),
            uniforms: Object.keys(this.uniforms)
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);

        if (json.uniforms) {
            json.uniforms.forEach(
                name => this.createUniform(name, 0));
        }
    }

    onVertexShader(shader) {
        this.vertexShader = shader;
        this.updateMaterial();
    }

    onFragmentShader(shader) {
        this.fragmentShader = shader;
        this.updateMaterial();
    }

    createUniform(name, value) {
        if (name in this.uniforms) {
            this.uniforms[name].value = value;
            if (isNaN(value)) {
                this.uniforms[name].type = "t";
            }
            if (this.material) {
                this.material.uniformsNeedUpdate = true;
            }
            return;
        }

        this.uniforms[name] = {
            value
        };

        if (isNaN(value)) {
            this.uniforms[name].type = "t";
        }

        this.newInlet(name, ([value]) => {
            this.uniforms[name].value = value;
            if (isNaN(value)) {
                this.uniforms[name].type = "t";
            }
            if (this.material) {
                this.material.uniformsNeedUpdate = true;
                this.sendMessage("material", this.material);
            }
        });
    }

    updateMaterial() {
        if (!this.fragmentShader || !this.vertexShader) {
            return;
        }

        let errorsBefore = window.errors.length;
        if (this.material) {
            this.material.fragmentShader = this.fragmentShader;
            this.material.vertexShader = this.vertexShader;
            this.material.needsUpdate = true;
        } else {
            // create the material with these 2 shaders
            this.material = new THREE.ShaderMaterial({
                uniforms: this.uniforms, 
                vertexShader: this.vertexShader,
                fragmentShader: this.fragmentShader,
                transparent: true,
                depthWrite: false,
                blending: THREE.NormalBlending
            });
        }

        let errorsAfter = window.errors.length;
        this.sendMessage("material", this.material);
    }

}

